<template>
  <SeoLandingPage :page="page" />
</template>

<script setup>
import page from "#build/page-data/solutions/agency-software-flat-pricing.mjs";
</script>
